import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useTheme } from '@mui/material';

export const Rocket = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <RocketLaunchIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
